import {v4 as uuid } from 'uuid';
import {
    animateInSuccess,
    animateInHavingTrouble,
} from '../../animations/animate';

export default async function subscriberStatusPoll () {

    if (!this.isStatusPolling) {
        this.limitCount = 0;
    }

    this.isStatusPolling = true;
    this.observed.isStatusPolling = uuid();
    const subscriberStore = this;
    const appStore = this.env.appStore;

    /* Actual Timing sweet spot */
    const limit = 40000; // will do 8 tries every 5 seconds
    const pollInterval = 4000;

    // force to fail
    /*
    const limit = 5000; // 15 tries every 2 seconds
    const pollInterval = 1000;
    */

    const res = await this.subscriberStatus();
    if (res.data) {
        if (res.data.statusLong.toLowerCase() === 'inactive') {
            // wait check status again
            this.limitCount += pollInterval;
            if (this.limitCount >= limit) {
                // try again...
                this.limitCount = 0;
                this.isStatusPolling = false;
                this.observed.isStatusPolling = uuid();
                appStore.gaAlmostDoneProcTimeout();
                animateInHavingTrouble(this.env);
                return;
            }
            setTimeout(() => {
                subscriberStore.subscriberStatusPoll();
            }, pollInterval);
        } else if (res.data.statusLong.toLowerCase() === 'active') {
            // appStore show success view
            this.limitCount = 0;
            this.isStatusPolling = false;
            this.observed.isStatusPolling = uuid();
            animateInSuccess(this.env);
        }
    }
}
